import React from "react";
import { Button } from "react-bootstrap"; // or wherever your Button comes from

interface Package {
  packageId: number;
  packageName: string;
  posterLink: string;
}

interface MyCoursePackagesProps {
  packages: Package[];
  packageId: number;
  MyCourses: (id: number) => void;
  setShowModule: (module: string) => void;
  Customized: string;
}

const MyCoursePackages: React.FC<MyCoursePackagesProps> = ({
  packages,
  packageId,
  MyCourses,
  setShowModule,
  Customized,
}) => {
  return (
    <div
      className="course-container"
      style={{ background: "#F6F6F0", padding: "20px", borderRadius: "8px" }}
    >
      <h3
        style={{
          textAlign: "center",
          color: "white",
          background: "black",
          padding: "10px",
          borderRadius: "8px",
        }}
      >
        My Courses
      </h3>

      <section style={{ background: "#343434", padding: "20px", borderRadius: "8px" }}>
        <div className="myCoursesPackage">
          {packages.map((pack) => (
            <div
              key={pack.packageId}
              style={{
                background: "black",
                border: "1px solid #ccc",
                borderRadius: "8px",
                width: "100%",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              <Button
                onClick={() => MyCourses(pack.packageId)}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  width: "100%",
                  display: "block",
                }}
              >
                <img
                  className="packagePosterShow"
                  src={pack.posterLink}
                  alt={pack.packageName}
                  style={{ objectFit: "fill", borderRadius: "8px 8px 0px 0px" }}
                />
                {pack.packageId <= packageId ? (
                  <span style={{ color: "green" }}>Purchased</span>
                ) : (
                  <span>Explore</span>
                )}
              </Button>
            </div>
          ))}
        </div>

        {packageId < 6 && (
          <div
            style={{
              background: "black",
              border: "1px solid #ccc",
              borderRadius: "8px",
              width: "100%",
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            <Button
              onClick={() => {
                setShowModule("customizedPackage");
                MyCourses(0);
              }}
              style={{
                textDecoration: "none",
                color: "inherit",
                width: "100%",
                display: "block",
              }}
            >
              <img
                className="packagePosterShow"
                src={Customized}
                alt="Customized Package"
                style={{ objectFit: "fill", borderRadius: "8px 8px 0px 0px" }}
              />
            </Button>
          </div>
        )}
      </section>
    </div>
  );
};

export default MyCoursePackages;